export const HERO_CONSTANTS = {
  TAG: "Wellness",
  DATE: "October 23, 2023",
  TITLE: "Experience Better Sleep with Grounding Sheets",
  DESCRIPTION:
    "Learn how grounding sheets can improve your sleep quality and overall well-being. Discover the science behind grounding and the benefits of incorporating grounding sheets into your sleep routine.",
  HERO_IMAGE:
    "https://images.pexels.com/photos/2345678/pexels-photo-2345678.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
};

export const ARTICLE_SUMMARY = [
  "Grounding sheets are designed to improve sleep quality and overall well-being by connecting you to the Earth's natural energy. This guide explores the science behind grounding and the benefits of using grounding sheets.",
  "From reducing inflammation to improving sleep, grounding sheets offer a range of health benefits. We'll delve into the different types of grounding sheets available and how to use them effectively.",
  "Whether you're looking to improve your sleep or enhance your overall health, grounding sheets provide a natural and effective solution. Let's explore the potential benefits and applications of grounding sheets.",
];

export const ARTICLE_STEPS = [
  {
    title: "1. Understanding Grounding Sheets",
    content:
      "Grounding sheets are made with conductive materials that connect you to the Earth's natural energy. These sheets are designed to reduce inflammation, improve sleep, and enhance overall well-being by grounding your body while you sleep.",
  },
  {
    title: "2. Benefits of Using Grounding Sheets",
    content:
      "Grounding sheets offer several benefits, including improved sleep quality, reduced inflammation, and enhanced overall health. By connecting to the Earth's energy, grounding sheets can help regulate your body's natural rhythms and promote better health.",
  },
  {
    title: "3. Applications in Wellness",
    content:
      "Grounding sheets can be used in a variety of wellness applications, from improving sleep to reducing stress. These sheets are ideal for anyone looking to enhance their overall health and well-being naturally.",
  },
  {
    title: "4. Choosing the Right Grounding Sheet",
    content:
      "When selecting a grounding sheet, consider factors such as material, size, and conductivity. Look for sheets made with high-quality conductive materials that are comfortable and durable.",
  },
  {
    title: "5. Tips for Using Grounding Sheets",
    content:
      "To get the best results from grounding sheets, use them consistently and follow the manufacturer's instructions. Ensure that the sheet is properly connected to a grounding source and that you are in direct contact with the sheet while sleeping.",
  },
  {
    title: "6. Maintenance and Care",
    content:
      "Keep your grounding sheet clean and well-maintained to ensure its effectiveness. Follow the manufacturer's care instructions and regularly check the sheet for any signs of wear or damage.",
  },
];

export const RELATED_ARTICLES = [
  {
    image:
      "https://images.pexels.com/photos/2345679/pexels-photo-2345679.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 20, 2023",
    title: "Top Wellness Trends for 2023",
    description:
      "Explore the latest wellness trends for 2023, from grounding sheets to natural supplements. Learn how to incorporate these trends into your daily routine.",
  },
  {
    image:
      "https://images.pexels.com/photos/2345680/pexels-photo-2345680.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 15, 2023",
    title: "How to Improve Your Sleep with Grounding Sheets",
    description:
      "Discover practical tips for improving your sleep with grounding sheets. Follow our step-by-step guide to achieve better sleep and overall health.",
  },
  {
    image:
      "https://images.pexels.com/photos/2345681/pexels-photo-2345681.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
    date: "October 12, 2023",
    title: "Choosing the Right Wellness Products for Your Needs",
    description:
      "Learn about the different wellness products available, from grounding sheets to essential oils. Understand the benefits and applications of each product to make informed decisions.",
  },
];

export const FOOTER_CONSTANTS = {
  CTA_TITLE: "Enhance Your Sleep with Grounding Sheets",
  CTA_BACKGROUND:
    "https://images.pexels.com/photos/2345682/pexels-photo-2345682.jpeg",
  EMAIL_PLACEHOLDER: "Enter your email address",
  BUTTON_TEXT: "Learn More",
  COPYRIGHT: " 2024 Wellness Trends. All rights reserved",
};
